"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuDesktop = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const theme_1 = require("../modules/theme");
const Menu_1 = require("./Menu");
class MenuDesktop extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    backgroundColor: theme.backgroundColor1,
                    height: react_native_1.Dimensions.get('window').height - this.props.headerHeight,
                    width: 250,
                    paddingHorizontal: 15,
                    paddingVertical: 15,
                    shadowOpacity: 0.31,
                    shadowRadius: 20,
                    shadowColor: theme.shadowColor1
                }
            });
            return styles;
        };
    }
    render() {
        const { menu, onMenuPress, isCurrentMenuPath, renderUserData } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.View, { style: styles.container },
            renderUserData ? React.createElement(react_native_1.View, null, renderUserData()) : null,
            React.createElement(Menu_1.Menu, { menu: menu, isCurrentMenuPath: isCurrentMenuPath, onMenuPress: onMenuPress })));
    }
}
exports.MenuDesktop = MenuDesktop;
MenuDesktop.defaultProps = {
    headerHeight: 0
};
